<div class="container-fluid p-0 edit-profile-page">

    <!-- HEADER -->
    <HeaderSection 
        :breadcrumb="breadcrumb"
        @breadcrumb-click="handleBreadcrumbClick"
    />


    <!-- MAIN -->
    <section class="container py-4">

        <div class="glass-card p-4 rounded-4">

            <h4 class="text-white fw-bold mb-4">Edit Profile</h4>

            <form @submit.prevent="saveProfile">

                <div class="row g-4">

                    <!-- Avatar -->
                    <div class="col-md-2 text-center text-md-start mb-3 mb-md-0">
                        <div class="profile-avatar d-flex align-items-center justify-content-center mx-auto mx-md-0">
                            <span class="profile-avatar-text">{{ avatar_initials }}</span>
                        </div>

                    </div>

                    <!-- Form Fields -->
                    <div class="col-md-9">

                        <div class="row g-3">

                            <!-- First Name -->
                            <div class="col-md-6">
                                <label class="form-label text-white-50">First Name</label>
                                <input 
                                    type="text" 
                                    class="form-control form-control-dark"
                                    v-model="form.first_name"
                                    required
                                >
                            </div>

                            <!-- Last Name -->
                            <div class="col-md-6">
                                <label class="form-label text-white-50">Last Name</label>
                                <input 
                                    type="text" 
                                    class="form-control form-control-dark"
                                    v-model="form.last_name"
                                    required
                                >
                            </div>

                            <!-- Email -->
                            <div class="col-md-6">
                                <label class="form-label text-white-50">Email Address</label>
                                <input 
                                    type="email" 
                                    class="form-control form-control-dark"
                                    v-model="form.email"
                                    readonly
                                >
                            </div>

                            <!-- Phone -->
                            <div class="col-md-6">
                                <label class="form-label text-white-50">Phone Number</label>
                                <input 
                                    type="tel"
                                    name="phone"
                                    pattern="[0-9]{10}"
                                    placeholder="0123456789"
                                    class="form-control form-control-dark"
                                    v-model="form.phone"
                                    required
                                >
                            </div>
                        </div>

                    </div>

                </div>

                <!-- BUTTONS -->
                <div class="d-flex justify-content-end mt-4 gap-3">
                    <button 
                        type="button" 
                        class="btn btn-outline-light btn-sm rounded-3 px-2 py-1 fw-light text-xs"
                        @click="cancelEdit"
                    >
                        Cancel
                    </button>

                    <button 
                        type="submit" 
                        class="btn btn-primary btn-sm rounded-3 px-3 py-1 fw-light text-xs"
                    >
                        Save Changes
                    </button>
                </div>

            </form>

        </div>

    </section>

</div>
